import React, { ReactNode } from "react";

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  body: string;
}

export default function FeatureCard({ icon, title, body }: FeatureCardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md dark:border-0 dark:bg-slate-800 dark:shadow-2xl dark:shadow-black/60">
      <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-700 dark:bg-slate-700 dark:text-blue-400">
        {icon}
      </div>
      <h3 className="mb-1.5 text-base font-medium text-gray-900 dark:text-gray-100">
        {title}
      </h3>
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
        {body}
      </p>
    </div>
  );
}
